import * as sessionSelectors from 'app_modules/session/selectors'
import actionTypes from 'app_modules/network/constants'
import api from 'api'

export const fetchNetworkLimitedMembersFailure = error => ({
  payload: error,
  type: actionTypes.FETCH_NETWORK_LIMITED_MEMBERS_FAILURE,
})

export const fetchNetworkLimitedMembersRequest = (pageIndex, search) => ({
  payload: { pageIndex, search },
  type: actionTypes.FETCH_NETWORK_LIMITED_MEMBERS_REQUEST,
})

export const fetchNetworkLimitedMembersSuccess = response => ({
  payload: response,
  type: actionTypes.FETCH_NETWORK_LIMITED_MEMBERS_SUCCESS,
})

export const fetchNetworkLimitedMembers = ({ pageIndex, search }, onSuccess, onError) => {
  const thunk = (dispatch, getState) => {
    const accountId = sessionSelectors.accountId(getState())

    dispatch(fetchNetworkLimitedMembersRequest(pageIndex, search))

    const handleResponse = response => {
      dispatch(fetchNetworkLimitedMembersSuccess(response))
      if (onSuccess) {
        onSuccess(response)
      }
    }

    const handleError = ({ error }) => {
      dispatch(fetchNetworkLimitedMembersFailure(error))
      if (onError) {
        onError(error)
      } else {
        throw error
      }
    }

    return api.profiles.getMyNetwork({ accountId, limitedMember: true, pageIndex, search }, handleResponse, handleError)
  }

  thunk.type = actionTypes.FETCH_NETWORK_LIMITED_MEMBERS

  return thunk
}

export default fetchNetworkLimitedMembers
